import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/reducers';
import AuthDropdown from '@/components/AuthMenuBar/AuthDropdown';
import { regex } from '@/utils';
import logoLetter from '@/assets/icons/letter.svg';
import logoPhone from '@/assets/icons/phone.svg';
import './styles.less';

const LandingHeader = () => {
  const { organisation } = useSelector((state: RootState) => state.openBankingDiretory);
  const [contact, setContact] = useState<{ logo: string; href: string }>({ logo: '', href: '' });
  const error: any = useSelector((state: RootState) => state.errors.FETCH_ENTITY);
  useEffect(() => {
    if (organisation) {
      const contactIsEmail = regex.email.test(organisation?.contact);
      const contactIsPhone = regex.phoneNumber.test(organisation?.contact);
      const contactIsValid = contactIsEmail || contactIsPhone;
      if (contactIsValid) {
        setContact({
          logo: contactIsEmail ? logoLetter : logoPhone,
          href: contactIsEmail ? 'mailto' : 'tel',
        });
      }
    }
  }, [organisation]);

  return (
    <div className="LandingHeader">
      <div className="LandingHeader-contact">
        <div className="LandingHeader-email">
          {organisation?.contact &&
            (contact.logo ? (
              <a href={`${contact.href}: ${organisation?.contact}`}>
                <img src={contact.logo} alt="Open Bank" />
                <span>{organisation?.contact}</span>
              </a>
            ) : (
              <span>{organisation?.contact}</span>
            ))}
        </div>
      </div>
      <div className="LandingHeader-login">
        {!error && <AuthDropdown componentNotLoginYet={<span>Admin Login</span>} />}
      </div>
    </div>
  );
};

export default React.memo(LandingHeader);
